"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const FormSection_1 = require("../../../utils/FormSection");
const EventSelection_1 = require("./EventSelection");
const EventConditionSelection_1 = require("./EventConditionSelection");
const EventPredicateList_1 = require("./EventPredicateList");
const EventAddCondition_1 = require("./EventAddCondition");
const EventDelay_1 = require("./EventDelay");
const EventTrigger = ({ device }) => (React.createElement(React.Fragment, null,
    React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
        React.createElement(src_1.Text, { text: "Event Trigger", size: "h1", textStyle: { marginBottom: 8 } }),
        React.createElement(EventSelection_1.default, { device: device }),
        React.createElement(EventConditionSelection_1.default, { device: device }),
        React.createElement(EventPredicateList_1.default, { device: device }),
        React.createElement(EventAddCondition_1.default, { device: device })),
    React.createElement(EventDelay_1.default, { device: device })));
exports.default = EventTrigger;
